/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-21 11:25:28
 * @LastEditTime: 2022-03-21 11:51:32
 * @LastEditors: Yandong Hu
 * @Description:
 */
import { atom } from "recoil";

const DialogRenameBoxVisibleState = atom({
  key: "dialogRenameBoxVisibleState",
  default: false,
});

const DialogService = {
    DialogRenameBoxVisibleState,
};

export default DialogService;
